/**
 * fileToAvatarDataUrl
 * Reads an image File, downscales it on a canvas to a small square-ish avatar,
 * and returns a JPEG data URL. Kept small (~256px) because the avatar string is
 * stored inline on the user and sent with every populated author in feeds.
 *
 * ponytail: data URL in Mongo, no S3/disk. Move to object storage + a CDN url
 * if avatars get heavy or feeds get large.
 */

export function fileToAvatarDataUrl(file, maxSize = 256, quality = 0.8) {
  return new Promise((resolve, reject) => {
    if (!file) return reject(new Error('No file selected.'));
    if (!file.type.startsWith('image/')) return reject(new Error('Please choose an image file.'));

    const reader = new FileReader();
    reader.onerror = () => reject(new Error('Could not read that file.'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Could not load that image.'));
      img.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
        const width = Math.max(1, Math.round(img.width * scale));
        const height = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', quality));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}
